<template>
  <section
    v-if="data"
    :class="$style.root"
  >
    <pages-editions-slug-component :data="data" />

    <nuxt-page :biennial-entry-id="data?.id" />
  </section>
  <shared-page-not-found-component v-else-if="!data" />
  <shared-error-component v-else-if="error" :error="error" />
</template>

<script lang="ts" setup>
// 1
definePageMeta({
  middleware: [
    function (to, from) {
      const router = useRouter()
      const localePath = useLocalePath()
      const toName = to?.name?.split('___')[0]
      if (toName === 'editions-slug') {
        router.push(localePath({ name: 'editions-slug-index-about', params: { slug: to.params.slug } }))
      }
    },
  ]
})

// 2
const { data, error } = await useAsyncData(() => $fetch('/api/strapi-rest', { query: { path: queryBiennialEntryBySlug(getPageQuery()) } } ) )
data.value = getFirstObject(data.value?.data)
setHead(data.value)

// 3
const colors = computed(() => data.value?.colors)

useHead({
  htmlAttrs: {
    style: getCssColors(colors.value)
  }
})
</script>

<style module>
.root {
  flex: 1;
}
</style>
